import { IconProps, Icon } from "@chakra-ui/react";

function TrashIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3333 5.50001V4.83334C13.3333 3.89992 13.3333 3.43321 13.1517 3.07669C12.9919 2.76308 12.7369 2.50812 12.4233 2.34833C12.0668 2.16667 11.6001 2.16667 10.6667 2.16667H9.33333C8.39991 2.16667 7.9332 2.16667 7.57668 2.34833C7.26308 2.50812 7.00811 2.76308 6.84832 3.07669C6.66667 3.43321 6.66667 3.89992 6.66667 4.83334V5.50001M8.33333 10.0833V14.25M11.6667 10.0833V14.25M2.5 5.50001H17.5M15.8333 5.50001V14.8333C15.8333 16.2335 15.8333 16.9335 15.5608 17.4683C15.3212 17.9387 14.9387 18.3212 14.4683 18.5609C13.9335 18.8333 13.2335 18.8333 11.8333 18.8333H8.16667C6.76654 18.8333 6.06647 18.8333 5.53169 18.5609C5.06129 18.3212 4.67883 17.9387 4.43915 17.4683C4.16667 16.9335 4.16667 16.2335 4.16667 14.8333V5.50001"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export default TrashIcon;
